// extracted by mini-css-extract-plugin
export default {"heading":"fz-z","corrected":"gz-z","redirectVerbiageContainer":"hz-z","redirectVerbiageText":"iz-z"};